import { Link, useLocation } from "react-router-dom";
import { useQuickAccess } from "../../contexts/QuickAccessContext";
import { usePermissions } from "../../contexts/PermissionsContext";

const BottomNavBar = () => {
  const location = useLocation();
  const { quickAccessPages } = useQuickAccess();
  const { hasPermission } = usePermissions();

  // Filter pages based on permissions
  const visiblePages = quickAccessPages.filter(page =>
    page.anyPermission
      ? page.anyPermission.some(p => hasPermission(p))
      : (!page.permission || hasPermission(page.permission))
  );

  // Don't render if no pages to show
  if (visiblePages.length === 0) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-md border-t border-border lg:hidden safe-area-bottom shadow-[0_-2px_10px_rgba(0,0,0,0.05)]">
      <div className="flex justify-around items-center h-16 px-1 max-w-lg mx-auto">
        {visiblePages.map((page) => {
          const Icon = page.icon;
          const isActive = location.pathname === page.href ||
            (page.href !== "/" && location.pathname.startsWith(page.href));

          return (
            <Link
              key={page.id}
              to={page.href}
              className={`flex flex-col items-center justify-center flex-1 h-full px-0.5 transition-all duration-200 ${
                isActive
                  ? "text-primary"
                  : "text-muted-foreground active:text-foreground"
              }`}
            >
              <div
                className={`flex items-center justify-center w-10 h-10 rounded-xl transition-all duration-200 ${
                  isActive ? "bg-primary/10 scale-105" : "active:scale-95"
                }`}
              >
                <Icon className={`w-5 h-5 transition-colors ${isActive ? "text-primary" : ""}`} />
              </div>
              <span
                className={`text-[9px] sm:text-[10px] mt-0.5 truncate max-w-[56px] sm:max-w-[64px] text-center leading-tight ${
                  isActive ? "font-semibold text-primary" : "font-medium"
                }`}
              >
                {page.name}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavBar;
